import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Info } from "lucide-react";

export const InfoPopover = () => (
  <Popover>
    <PopoverTrigger asChild>
      <Button 
        variant="ghost" 
        size="icon"
        className="h-6 w-6 p-0"
      >
        <Info className="h-5 w-5 text-gray-400" />
      </Button>
    </PopoverTrigger>
    <PopoverContent>
      <p className="text-sm">
        A score between 1-5 that represents your portfolio's risk level based on your <span className="font-bold">current</span> asset allocation.
      </p>
    </PopoverContent>
  </Popover>
);